import Glide from '@glidejs/glide'

export default {
	init() {

		const updateSlider = (allElements, activeItem) => {
			const current = document.querySelector(".count__current");
			const length = document.querySelector(".count__length");
			length.textContent = `${allElements}`;
			current.textContent = `${activeItem + 1}`;
		};

		let glide = new Glide('.glide--intro', {
			type: 'carousel',
			startAt: 0,
			perView: 1.5,
			gap: -50,
			breakpoints: {
				480: {
					gap: 0,
				}
			}
		}).mount();

		let allSlides = document.querySelectorAll('.glide__slide').length;
		let clonedSlides = document.querySelectorAll('.glide__slide--clone').length;
		let numberOfSlides = allSlides - clonedSlides;

		glide.on('move.after', function() {
			updateSlider(numberOfSlides, glide.index)
		});

		/* Rewards */

		const rewardBtns = document.querySelectorAll(".rewards__btn");
		rewardBtns.forEach((btn, index) => {
			rewardBtns[0].classList.add("rewards__btn--active");
			btn.addEventListener("click", (e) => {
				rewardBtns.forEach(btn => btn.classList.remove("rewards__btn--active"));
				e.currentTarget.classList.add("rewards__btn--active");
			});
		});

	},
	finalize() {

	},
};
